var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewIconGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 733.3 333.3",
    style: {
      enableBackground: "new 0 0 733.3 333.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#24CE44;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000085938736663642450350000007949865441997489795_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 45,
    width: 618,
    height: 236
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000006671633604351306690000018224984749482822839_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000176722248566537252460000008845169596448725422_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M642.9,0H91.5C41,0,0,41,0,91.5v150.9c0,50.2,40.7,90.9,90.9,90.9H643c49.8,0,90.3-40.4,90.3-90.3V90.4 C733.3,40.5,692.8,0,642.9,0z M254,250h-40.2c-0.3,0-0.7-0.2-0.8-0.5l-49.7-82.8L151.7,145l0,0v104c0,0.5-0.4,1-1,1h-38 c-0.5,0-1-0.4-1-1V84.3c0-0.5,0.4-1,1-1h40.2c0.3,0,0.7,0.2,0.8,0.5l49.7,82.8c0,0,0,0.1,0.1,0.1l9.7,21.1 c0.2,0.3,0.5,0.6,0.9,0.6l0,0c0.6,0,1-0.5,1-1.1c-0.3-4.2-1.6-19.9-1.6-25.6V84.3c0-0.5,0.4-1,1-1H254c0.5,0,1,0.4,1,1V249 C255,249.6,254.6,250,254,250z M405.7,250H279.3c-0.5,0-1-0.4-1-1V84.3c0-0.5,0.4-1,1-1H404c0.5,0,1,0.4,1,1v31.3 c0,0.5-0.4,1-1,1h-83c-0.5,0-1,0.4-1,1v28c0,0.5,0.4,1,1,1h71.3c0.5,0,1,0.4,1,1V179c0,0.5-0.4,1-1,1H321c-0.5,0-1,0.4-1,1v33 c0,0.5,0.4,1,1,1h84.7c0.5,0,1,0.4,1,1v33C406.7,249.6,406.3,250,405.7,250z M587.5,250h-40.1c-0.5,0-0.9-0.3-1-0.8L530,170 c-3.3-13.3-6.7-31.7-6.7-31.7l0,0c0,0-3.3,18.3-5,31.7v0.1l-18.1,79.2c-0.1,0.4-0.5,0.8-1,0.8h-38.5c-0.4,0-0.8-0.3-0.9-0.7 L413.7,84.5c-0.2-0.6,0.3-1.2,0.9-1.2h39.6c0.5,0,0.9,0.3,1,0.8l16.5,69.2c3.7,13.7,6.4,27.6,8.3,41.7l0,0l8.3-40l16.5-70.9 c0.1-0.4,0.5-0.8,1-0.8h36.7c0.5,0,0.9,0.3,1,0.8l14.8,70.9l8.3,40l0,0l8.3-41.7l16.5-69.2c0.1-0.4,0.5-0.8,1-0.8H632 c0.6,0,1.1,0.6,1,1.2l-44.5,164.7C588.4,249.7,588,250,587.5,250z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewIconGreen);
export default __webpack_public_path__ + "static/media/new_icon_green.5fa93f02a48a180afb30ae2d14f78c9d.svg";
export { ForwardRef as ReactComponent };